import { Component, EventEmitter, Output, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'overlapping-engagement-summary',
  templateUrl: './overlapping-engagement-summary.component.html',
  styleUrls: ['./overlapping-engagement-summary.component.scss'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})

export class OverlappingEngagementSummaryComponent {
  @Output() public onSummaryClick = new EventEmitter<any>();
}
